<template>
  <div class="basalsTable_module" :style="style" :class="{ 'basalsTable_module--onlyOne': notFirst7Patch, isLongLanguage, 'basalsTable_module--last': isLast, 'basalsTable_module--active': isActive }">
    <div class="basalsTable_titleRow">
      <div v-if="isFirst" class="basalsTable_titleRow--first">
        00:00 00:00
      </div>
      <div v-else class="basalsTable_titleRow--oneColumn">
        {{ setting['settingName'] ? setting['settingName'] : '' }}<sub v-show="(setting['isActive'] + '').trim() === '0'">*</sub>
      </div>
    </div>
    <div v-for="j in 24" :key="`bt_cr_${j}`" class="basalsTable_contentRow" :class="{ 'basalsTable_contentRow--firstRow': j === 1, 'basalsTable_contentRow--lastRow': j === 24 }">
      <div v-if="isFirst" class="basalsTable_contentRow--first">
        {{ `${j - 1}`.padStart(2, '0') }}:00
      </div>
      <div v-else :key="`bt_cr_oc_${j}`" class="basalsTable_contentRow--oneColumn">
        {{ setting['values'] ? setting['values'][j - 1] : '' }}
      </div>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
const derror = derrorFactory('BolusCalculatorSettingTable.vue', false)
const error = errorFactory('BolusCalculatorSettingTable.vue', true)

let _id = 1
export default {
  name: 'CBolusCalculatorSettingTableV3Module',
  components: {
  },
  mixins: [reDrawTrigger],
  props: {
    setting: {
      type: [Object],
      default: () => {}
    },
    isFirst: {
      type: [Number, Boolean, String],
      default: () => false
    },
    isLast: {
      type: [Number, Boolean, String],
      default: () => false
    },
    notFirst7Patch: {
      type: [Number, Boolean, String],
      default: () => false
    },
  },
  data() {
    _id++
    const id = `basalstablev3module_${+new Date()}_${_id}`
    
    return {
      id,
    }
  },
  computed: {
    isActive() {
      // eslint-disable-next-line
      const { setting = {} } = this
      const rst = (setting['isActive'] + '').trim() === '0'
      return rst
    },
    w() {      
      const { ds } = this
      
      return ds * (132 / 1740)
      // return ds * (760 / 1740)
      // return ds * (1140 / 1740) // 这个才对得起3列。750是2列。但是3列的话右侧放不下了
      // return ds * (1160 / 1740)
    },
    style() {
      const { w, isLast, isFirst, notFirst7Patch } = this
      const rst = { width: `${w}px` }
      
      if (!notFirst7Patch) {
        if (isLast) {
          rst.width = `${w - 14 * 2}px`
        } else if (isFirst) {
          rst.width = `${w * (49 / 110) - 14 * 2}px`
        } 
      } else {
        // 第二组8-14的预设值module
        rst.width = `${w - 14 * 1}px`
      }
      
      return rst
    }
  },
  mounted() {
    // if (!this.isFirst) {
    //   setTimeout(() => {
    //     console.error(`setting`, this.setting)
    //     console.error(`setting`, {
    //       notFirst7Patch: this.notFirst7Patch,
    //       i: this.i
    //     })
    //   }, 1000 * 2) 
    // }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 40px;

$c-active: rgba(179, 209, 98, 1);
$c-active--light: rgba(210, 228, 185, 1);

.basalsTable_module {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    vertical-align: top;
    @include bBox;
    
    .basalsTable_titleRow--first, .basalsTable_contentRow--first {
        width: 60 / 1023 * 100%;
    }
    .basalsTable_titleRow--oneColumn, .basalsTable_contentRow--oneColumn {
        width: 100%;
    }
    .basalsTable_titleRow--oneColumn sub {
        position: relative;
        top: -0.5em;
        right: -0.1em;
    }
    .basalsTable_titleRow {
        @include bBox;
        height: $rowH;
        margin-bottom: 10px;
        @include flexRow(space-between, center);
        .basalsTable_titleRow--oneColumn {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            @include heightMiddle($rowH);
            text-align: center;
            border-radius: 4px;
            .ctn-unit {
                margin-left: 0.4em;
            }
        }
        .basalsTable_titleRow--first {
            color: white;
            /* color: rgba(0, 0, 0, 0.5); */
            font-size: 16px;
            text-align: center;
            @include heightMiddle($rowH);
        }
    }
    .basalsTable_contentRow {
        $h: 26px;
        $r: 4px;
        @include bBox;
        @include flexRow(space-between, center);
        font-weight: normal;
        border-bottom: 0.5px solid $colorEchartStripeInnerBorder;
        > * {
            display: inline-block;
            vertical-align: middle;
        }
        .basalsTable_contentRow--first {
            color: rgba(0, 0, 0, 0.5);
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            font-size: calc(16em / 18);            
            font-weight: 600;
            text-align: center;
            @include heightMiddle($h);
        }
        .basalsTable_contentRow--oneColumn {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            @include heightMiddle($h);
            text-align: center;
            .ctn-unit {
                margin-left: 0.4em;
            }
        }
        
        &.basalsTable_contentRow--firstRow {
            .basalsTable_contentRow--oneColumn {
                border-top-left-radius: $r;
                border-top-right-radius: $r;
            }
        }
        &.basalsTable_contentRow--lastRow {
            border-bottom-right-radius: $r;
            border-bottom: none;
            .basalsTable_contentRow--oneColumn {
                border-bottom-left-radius: $r;
                border-bottom-right-radius: $r;
            }
        }
    }
    .basalsTable_titleRow .basalsTable_titleRow--oneColumn, .basalsTable_contentRow .basalsTable_contentRow--oneColumn {
        margin: 0 14px;
    }
    &.basalsTable_module--last {
        .basalsTable_titleRow .basalsTable_titleRow--oneColumn, .basalsTable_contentRow .basalsTable_contentRow--oneColumn {
            margin: 0 0;
        }
    }
    &.basalsTable_module--onlyOne {
        .basalsTable_titleRow .basalsTable_titleRow--oneColumn, .basalsTable_contentRow .basalsTable_contentRow--oneColumn {
            margin: 0 0 0 14px;
        }   
    }
    
    &.basalsTable_module--active {
        .basalsTable_titleRow .basalsTable_titleRow--oneColumn {
            background-color: $c-active;
        }
        .basalsTable_contentRow .basalsTable_contentRow--oneColumn {
            background-color: $c-active--light;
        }
    }
}
</style>
